const CartStateLocalStorageUtil = {
    getAll() {
      let selectedCartItem = localStorage.getItem('hellostore.cart_items_checkbox_state');
      if(selectedCartItem){
        return JSON.parse(selectedCartItem);
      }else{
        return [];
      }
    },
    delete(index) {
      const removedElm = document.querySelector("input[data-index='"+index+"']");
      if(removedElm){
        let cartItems = this.getAll();
        const cartIndex = cartItems.findIndex(localCartItem => localCartItem.variantId==removedElm.dataset.checkboxVariantId);
        if(cartIndex > -1){
          cartItems.splice(cartIndex,1);
          this.update(cartItems);
        }
      }
    },
    deleteByVariantId(variantId) {
      let cartItems = this.getAll();
      const cartIndex = cartItems.findIndex(item => String(item.variantId) === String(variantId));
      if (cartIndex > -1) {
        cartItems.splice(cartIndex,1);
        this.update(cartItems);
      }
    },
    clearCart(options) {
     fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        })
        .then((res) => {
            return res.text();
        }).then((res) =>{
          if (options && typeof options.onSuccess == "function") {
            options.onSuccess();
          } 
        }).catch(err => {
          console.error(err);
        });
    },
    update(cartData) {
      localStorage.setItem("hellostore.cart_items_checkbox_state", JSON.stringify(cartData));
    },
    addStateToCart(options) {
      const cartItemsState = this.getAll();
      if (cartItemsState.length > 0) {
        const items = cartItemsState.map(item => ({
          quantity: item.quantity,
          id: item.variantId,
          properties: item.lineItemProperties
        }));
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          })
          .then(res => {
            return res.text();
          })
          .then((res) => {
            const parsedResponse = JSON.parse(res);
            if (parsedResponse.status && String(parsedResponse.status) === "422") {
              // exact quantity of the items is no longer available,
              // so we need to adjust the quantity and then try to add again
              const query = cartItemsState.map((item, index) => {
                let queryPart = `id:${item.productId}`;
                if (index > 0) {
                  queryPart = `OR ${queryPart}`;
                }
                return queryPart;
              }).join(" ");
              const searchApiUrl = `/search?type=product&view=bulkvariantquantitiesjson&q=${query}`;
              fetch(searchApiUrl, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
              })
                .then(response => response.json())
                .then(result => {
                  const correctedItemsState = [];
                  cartItemsState.forEach(itemState => {
                    const product = result.products.find(product => String(product.id) === String(itemState.productId));
                    if (product) {
                      const variant = product.variants.find(variant => String(variant.id) === String(itemState.variantId));
                      if (variant && variant.inventory_quantity > 0) {
                        const correctedQuantity = variant.inventory_quantity > itemState.quantity
                          ? itemState.quantity
                          : variant.inventory_quantity;
                        correctedItemsState.push({
                          ...itemState,
                          quantity: correctedQuantity
                        });
                      }
                    }
                  })
                  this.update(correctedItemsState);
                  this.clearCart({
                    onSuccess: () => {
                      this.addStateToCart(options);
                    }
                  })
                })
                .catch(err => {
                  console.error(err);
                });
            } else if (parsedResponse.items && parsedResponse.items.length > 0) {
              if (options && typeof options.onSuccess === 'function') {
                options.onSuccess(res);
              }
            }
          })
          .catch((err) => {
            console.error(err);
          })
      } else {
        options.onSuccess();
      }
    }
} 